<div class="min-h-screen bg-gray-50 p-4 md:p-6">
  <div class="max-w-7xl mx-auto space-y-6">
    <!-- Header Section -->
    <div
      class="flex flex-col md:flex-row md:items-center md:justify-between gap-4"
    >
      <div class="space-y-1">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900">
          Gerenciamento de Vendas
        </h1>
        <p class="text-gray-600">Acompanhe e gerencie suas vendas</p>
      </div>

      <!-- Header Actions -->
      <div class="flex gap-3">
        <button
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          (click)="newSale()"
          aria-label="Criar nova venda"
        >
          <span class="material-icons text-sm mr-2">add_shopping_cart</span>
          Nova Venda
        </button>
      </div>
    </div>

    <!-- Stats Cards Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <!-- Total Sales Card -->
      <div class="bg-white rounded-lg shadow p-6">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div
              class="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center"
            >
              <span class="material-icons text-primary-600">shopping_cart</span>
            </div>
          </div>
          <div class="ml-4 flex-1">
            <div class="text-sm font-medium text-gray-500">Total de Vendas</div>
            <div class="text-2xl font-bold text-gray-900">
              {{ totalSales() }}
            </div>
            <div class="text-xs text-gray-500 mt-1">Vendas concluídas</div>
          </div>
        </div>
      </div>

      <!-- Revenue Card -->
      <div class="bg-white rounded-lg shadow p-6">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div
              class="w-10 h-10 bg-secondary-100 rounded-lg flex items-center justify-center"
            >
              <span class="material-icons text-secondary-600"
                >attach_money</span
              >
            </div>
          </div>
          <div class="ml-4 flex-1">
            <div class="text-sm font-medium text-gray-500">Faturamento</div>
            <div class="text-2xl font-bold text-gray-900">
              {{ totalRevenue() | currency : "BRL" : "symbol" : "1.2-2" }}
            </div>
            <div class="text-xs text-gray-500 mt-1">Total arrecadado</div>
          </div>
        </div>
      </div>

      <!-- Average Ticket Card -->
      <div class="bg-white rounded-lg shadow p-6">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div
              class="w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center"
            >
              <span class="material-icons text-accent-600">receipt</span>
            </div>
          </div>
          <div class="ml-4 flex-1">
            <div class="text-sm font-medium text-gray-500">Ticket Médio</div>
            <div class="text-2xl font-bold text-gray-900">
              {{ averageTicket() | currency : "BRL" : "symbol" : "1.2-2" }}
            </div>
            <div class="text-xs text-gray-500 mt-1">Valor médio por venda</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filters Section -->
    <div class="bg-white rounded-lg shadow p-6">
      <form
        [formGroup]="filterForm"
        class="space-y-4 md:space-y-0 md:flex md:items-end md:gap-4"
      >
        <!-- Search Input -->
        <div class="flex-1">
          <label
            for="search"
            class="block text-sm font-medium text-gray-700 mb-1"
          >
            Buscar vendas
          </label>
          <div class="relative">
            <input
              id="search"
              type="text"
              formControlName="search"
              placeholder="Cliente, email, ID da venda..."
              class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            />
            <div
              class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
            >
              <span class="material-icons text-gray-400 text-sm">search</span>
            </div>
          </div>
        </div>

        <!-- Status Select -->
        <div class="md:w-48">
          <label
            for="status"
            class="block text-sm font-medium text-gray-700 mb-1"
          >
            Status
          </label>
          <select
            id="status"
            formControlName="status"
            class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
          >
            @for (status of statusOptions; track status.value) {
            <option [value]="status.value">{{ status.label }}</option>
            }
          </select>
        </div>

        <!-- Results Info -->
        <div class="md:w-auto">
          <div class="text-sm text-gray-600 whitespace-nowrap">
            {{ resultCount() }} venda(s) encontrada(s)
          </div>
        </div>
      </form>
    </div>

    <!-- Loading State -->
    @if (isLoading()) {
    <div class="bg-white rounded-lg shadow p-12">
      <div class="flex items-center justify-center">
        <div class="text-center space-y-3">
          <div
            class="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto"
          ></div>
          <p class="text-gray-600">Carregando vendas...</p>
        </div>
      </div>
    </div>
    }

    <!-- Empty State -->
    @if (showEmptyState()) {
    <div class="bg-white rounded-lg shadow p-12">
      <div class="text-center space-y-4">
        <span class="material-icons text-6xl text-gray-400">shopping_cart</span>
        <div>
          <h3 class="text-lg font-medium text-gray-900">
            Nenhuma venda encontrada
          </h3>
          <p class="text-gray-500 mt-1">
            Tente ajustar os filtros ou registre uma nova venda
          </p>
        </div>
        <button
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          (click)="newSale()"
        >
          <span class="material-icons text-sm mr-2">add_shopping_cart</span>
          Nova Venda
        </button>
      </div>
    </div>
    }

    <!-- Sales Table/Cards -->
    @if (!isLoading() && filteredSales().length > 0) {
    <div class="bg-white rounded-lg shadow">
      <!-- Mobile View (Cards) -->
      <div class="block lg:hidden">
        <div class="p-4 space-y-4">
          @for (sale of filteredSales(); track sale.id) {
          <div class="border border-gray-200 rounded-lg p-4 space-y-3">
            <div class="flex items-start justify-between">
              <div class="flex-1">
                <div class="flex items-center gap-2 mb-2">
                  <span class="text-sm font-medium text-gray-900"
                    >#{{ sale.id }}</span
                  >
                  <span
                    class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                    [class]="getStatusClass(sale.status)"
                  >
                    {{ getStatusText(sale.status) }}
                  </span>
                </div>
                <h3 class="font-medium text-gray-900">
                  {{ sale.customerName }}
                </h3>
                <p class="text-sm text-gray-500">{{ sale.customerEmail }}</p>
                <div class="text-sm text-gray-500 mt-1">
                  Vendedor: {{ sale.salesperson }}
                </div>
              </div>
              <div class="text-right">
                <div class="text-lg font-semibold text-gray-900">
                  {{ sale.total | currency : "BRL" : "symbol" : "1.2-2" }}
                </div>
                <div class="text-sm text-gray-500">
                  {{ sale.paymentMethod }}
                </div>
                <div class="text-xs text-gray-400 mt-1">
                  {{ formatDate(sale.createdAt) }}
                </div>
              </div>
            </div>

            <div
              class="flex items-center justify-between pt-3 border-t border-gray-100"
            >
              <div class="text-sm text-gray-500">
                {{ sale.items.length }} item(ns)
              </div>
              <div class="flex space-x-2">
                <button
                  class="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                  (click)="viewSale(sale)"
                  aria-label="Ver detalhes da venda"
                >
                  <span class="material-icons text-sm">visibility</span>
                </button>
                <button
                  class="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                  (click)="editSale(sale)"
                  aria-label="Editar venda"
                >
                  <span class="material-icons text-sm">edit</span>
                </button>
                <button
                  class="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  (click)="deleteSale(sale)"
                  aria-label="Excluir venda"
                >
                  <span class="material-icons text-sm">delete</span>
                </button>
              </div>
            </div>
          </div>
          }
        </div>
      </div>

      <!-- Desktop View (Table) -->
      <div class="hidden lg:block">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  ID / Cliente
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Itens
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Total
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Status
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Pagamento
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Data
                </th>
                <th
                  class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Ações
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              @for (sale of filteredSales(); track sale.id) {
              <tr class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div>
                    <div class="text-sm font-medium text-gray-900">
                      #{{ sale.id }}
                    </div>
                    <div class="text-sm font-medium text-gray-900">
                      {{ sale.customerName }}
                    </div>
                    <div class="text-sm text-gray-500">
                      {{ sale.customerEmail }}
                    </div>
                    <div class="text-xs text-gray-400">
                      Vendedor: {{ sale.salesperson }}
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ sale.items.length }} item(ns)
                </td>
                <td
                  class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                >
                  {{ sale.total | currency : "BRL" : "symbol" : "1.2-2" }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                    [class]="getStatusClass(sale.status)"
                  >
                    {{ getStatusText(sale.status) }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ sale.paymentMethod }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ formatDate(sale.createdAt) }}
                </td>
                <td
                  class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                >
                  <div class="flex justify-end space-x-2">
                    <button
                      class="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                      (click)="viewSale(sale)"
                      aria-label="Ver detalhes da venda"
                    >
                      <span class="material-icons text-sm">visibility</span>
                    </button>
                    <button
                      class="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
                      (click)="editSale(sale)"
                      aria-label="Editar venda"
                    >
                      <span class="material-icons text-sm">edit</span>
                    </button>
                    <button
                      class="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                      (click)="deleteSale(sale)"
                      aria-label="Excluir venda"
                    >
                      <span class="material-icons text-sm">delete</span>
                    </button>
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
  </div>
</div>
